import {
    GET_DEPARTMENTS_FAIL,
    GET_DEPARTMENTS_SUCCESS,
    ADD_DEPARTMENT_SUCCESS,
    ADD_DEPARTMENT_FAIL,
    UPDATE_DEPARTMENT_SUCCESS,
    UPDATE_DEPARTMENT_FAIL,
    DELETE_DEPARTMENT_SUCCESS,
    DELETE_DEPARTMENT_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    departments: [],
    error: null,
    loading: true
};

const departmentReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des departments
        case GET_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                departments: action.payload, // tableau d'objets branch
                loading: false,
                error: null
            };

        case GET_DEPARTMENTS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une department
        case ADD_DEPARTMENT_SUCCESS:
            return {
                ...state,
                departments: [action.payload, ...state.departments], // ajoute au début du tableau
                error: null
            };

        case ADD_DEPARTMENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une department
        case UPDATE_DEPARTMENT_SUCCESS:
            return {
                ...state,
                departments: state.departments.map(branch =>
                    branch.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet branch
                        : branch
                ),
                error: null
            };

        case UPDATE_DEPARTMENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une department
        case DELETE_DEPARTMENT_SUCCESS:
            return {
                ...state,
                departments: state.departments.filter(
                    branch => branch.id !== action.payload
                ),
                error: null
            };


        case DELETE_DEPARTMENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default departmentReducer;
